'use strict'

module.exports = require('./utils/interpolate').interpolateArray(require('./hex/viridis.json'))
